import { FormControl, FormGroup } from '@angular/forms';
import { ClientCreditNoteDraftItem } from 'shared';
import {
  conditionStringValidator,
} from 'shared';

type FormShape = {
  reference: FormControl<string>;
  articleNumber: FormControl<string>;
  amount: FormControl<number | null>;
  purchasePrice: FormControl<number | null>;
  conditionString: FormControl<string>;
  basicNetPrice: FormControl<number | null>;
  taxPrice: FormControl<number | null>;
};

export class DraftItemFormManager {
  private forms = new Map<string, FormGroup<FormShape>>();

  get(id: string) {
    return this.forms.get(id);
  }

  getAll() {
    return this.forms;
  }

  upsert(draftItem: ClientCreditNoteDraftItem, locked: boolean) {
    const id = draftItem['@id']!;
    let form = this.forms.get(id);
    if (!form) {
      form = this.#initForm();
      this.forms.set(id, form);
    } else {
      this.#patchForm(form, draftItem);
    }

    if (locked) form.disable();
    else form.enable();
  }

  syncFromDraftItems(
    draftItems: ClientCreditNoteDraftItem[] | null | undefined,
    locked: boolean,
  ) {
    const seen = new Set<string>();
    for (const item of draftItems ?? []) {
      if (!item?.['@id']) continue;
      seen.add(item['@id']!);
      this.upsert(item, locked);
    }
    // prune
    for (const id of Array.from(this.forms.keys())) {
      if (!seen.has(id)) this.forms.delete(id);
    }
  }

  setLocked(locked: boolean) {
    for (const form of this.forms.values()) {
      if (locked) form.disable();
      else form.enable();
    }
  }

  #initForm() {
    const form = new FormGroup<FormShape>({
      reference: new FormControl('', {
        nonNullable: true,
        validators: [],
      }),
      articleNumber: new FormControl('', {
        nonNullable: true,
        validators: [],
      }),
      amount: new FormControl(null, {
        validators: [],
      }),
      purchasePrice: new FormControl(null, {
        validators: [],
      }),
      conditionString: new FormControl('', {
        nonNullable: true,
        validators: [conditionStringValidator],
      }),
      basicNetPrice: new FormControl(null, {
        validators: [],
      }),
      taxPrice: new FormControl(null, {
        validators: [],
      }),
    });
    form.updateValueAndValidity();
    return form;
  }

  #patchForm(form: FormGroup<FormShape>, item: ClientCreditNoteDraftItem) {
    form.patchValue({
      reference: item.reference ?? '',
      articleNumber: item.articleNumber,
      amount: item.amount,
      purchasePrice: item.purchasePrice,
      conditionString: item.conditionString,
      basicNetPrice: item.basicNetPrice,
      taxPrice: item.taxPrice,
    });
    form.updateValueAndValidity();
  }
}
